import { phaseOf, type TournamentSummary } from "./tournament";
import type { ScheduledGame } from "./types";

export type TournamentState = "ended" | "registration" | "draft" | "upcoming" | "inProgress";

/** The public board and organiser header describe the same event lifecycle.
 * Past dates or end times with unfinished games keep the event in progress. */
export function tournamentState(
  meta: Pick<TournamentSummary, "status" | "startDate" | "endDate" | "endTime" | "timezone">,
  schedule: readonly ScheduledGame[],
  now: string | Date,
): TournamentState {
  const phase = phaseOf(meta, now);
  if (meta.status === "archived" || (phase === "past" && !schedule.some((g) => g.result === undefined)))
    return "ended";
  if (meta.status === "registration") return "registration";
  if (meta.status === "draft") return "draft";
  return phase === "upcoming" ? "upcoming" : "inProgress";
}
